/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_TitleInputs */

const en_mk_aicost_title = /** @type {(inputs: Mk_Aicost_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What one agent task actually costs`)
};

const id_mk_aicost_title = /** @type {(inputs: Mk_Aicost_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa sebenarnya biaya satu tugas agen`)
};

/**
* | output |
* | --- |
* | "What one agent task actually costs" |
*
* @param {Mk_Aicost_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_title = /** @type {((inputs?: Mk_Aicost_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_title(inputs)
	return en_mk_aicost_title(inputs)
});